import { createSlice } from "@reduxjs/toolkit";

const mockSonicosDeviceTemplate = {
  modelName: "DCS-7280SR-48C6",
  hardwareVersion: "A1",
  version: "10.2.4",
  brandName: "D-Link",
  productName: "Data Center Switch 7280",
};

const makeDiscoveryResults = (request = {}) => {
  if (request.action !== "start") return [];

  return (request.data || []).flatMap((item) => {
    const ipAddress = item.ipList?.[0];
    if (!ipAddress) return [];
    // Mock credentials: admin / Aa@12345 succeeds; other credentials exercise
    // the AuthenticationRejected flow in the drawer and batch action.
    const authenticated = item.username === "admin" && item.password === "Aa@12345";
    if (!authenticated) {
      return [{
        ipAddress,
        deviceIPAddress: ipAddress,
        status: "failed",
        error: {
          kind: "AuthenticationRejected",
          message: "The username or password is incorrect.",
        },
      }];
    }

    const suffix = Number(ipAddress.split(".").pop() || 0).toString(16).padStart(2, "0");
    return [{
      status: "success",
      ...mockSonicosDeviceTemplate,
      deviceIPAddress: ipAddress,
      macAddress: `00:11:22:33:44:${suffix.padStart(2, "0")}`,
    }];
  });
};

export const sonicosDiscoverySlice = createSlice({
  name: "sonicosDiscovery",
  initialState: {
    resource: "/sonicos/discovery",
    data: [],
  },
  reducers: {
    setSonicosDiscoveryRequest(state, action) {
      if (action.payload.discoveryProtocol !== "sonicos") return;
      state.resource = "/sonicos/discovery";
      state.data = makeDiscoveryResults(action.payload);
    },
    setSonicosAdoptRequest(state, action) {
      const devices = action.payload.devices || [];
      if (!devices.some((device) => device.protocolType === "sonicos")) return;
      state.resource = "/devices/provision/adopt";
      state.data = devices.map((device) => ({
        code: 0,
        macAddress: device.deviceId,
        message: "Success",
      }));
    },
  },
});

export const { setSonicosDiscoveryRequest, setSonicosAdoptRequest } = sonicosDiscoverySlice.actions;
export default sonicosDiscoverySlice.reducer;
